import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const ReceiptSummary = ({ paymentId, subscriptionId, receipt, paidThrough, testId = "payment-receipt" }) => {
  const [email, setEmail] = useState(receipt);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { setEmail(receipt); }, [receipt]);
  if (!paymentId || !subscriptionId) return null;
  const retry = async () => {
    setBusy(true); setError("");
    try { const { data } = await api.post(`/payments/receipts/${encodeURIComponent(paymentId)}/retry`); setEmail(data); }
    catch (e) { setError(apiError(e)); } finally { setBusy(false); }
  };
  const labels = { pending: "Queued", sending: "Sending", sent: "Accepted by email provider — delivery not yet confirmed", delivered: "Delivered", failed: "Send failed — paid access is unaffected", cancelled: "Not sent — payment no longer eligible", bounced: "Delivery failed — paid access is unaffected" };
  return <div data-testid={testId} className="space-y-2 rounded-xl border border-current/20 p-3 text-xs">
    <p data-testid={`${testId}-payment`} className="break-all"><b>Razorpay payment:</b> {paymentId}</p>
    <p data-testid={`${testId}-subscription`} className="break-all"><b>Razorpay subscription:</b> {subscriptionId}</p>
    {paidThrough && <p data-testid={`${testId}-paid-through`}>Paid through: {new Date(paidThrough).toLocaleString()}</p>}
    <p data-testid={`${testId}-email`}><b>Confirmation email:</b> {labels[email?.status] || "Pending receipt creation"}</p>
    {email?.error && <p data-testid={`${testId}-email-error`}>{email.error}</p>}
    {email?.status && email.status !== "delivered" && email.status !== "cancelled" && <Button data-testid={`${testId}-retry`} size="sm" variant="outline" disabled={busy} onClick={retry} className="rounded-full text-slate-900">{busy ? "Checking…" : email.status === "sent" ? "Check email delivery" : "Retry receipt email (no charge)"}</Button>}
    {error && <p role="alert" data-testid={`${testId}-error`}>{error}</p>}
  </div>;
};
